var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "el",
      staticClass: "title flex items-center",
      on: {
        click: function ($event) {
          $event.stopPropagation()
          return _vm.handlePopoverShow.apply(null, arguments)
        },
      },
    },
    [
      _vm.getTitleInfo.type === "AI"
        ? _c("img", {
            staticClass: "title-icon",
            attrs: { src: require("@/assets/image/aigc/icon.png"), alt: "" },
          })
        : [
            !!_vm.getTitleInfo.icon
              ? _c("img", {
                  staticClass: "title-icon",
                  attrs: { src: _vm.getTitleInfo.icon, alt: "" },
                })
              : _c(
                  "div",
                  {
                    staticClass: "title-span",
                    style: {
                      background: _vm.getTitleInfo.backgroundColor,
                    },
                  },
                  [
                    _c(
                      "span",
                      {
                        style: {
                          color: _vm.getTitleInfo.textColor,
                        },
                      },
                      [_vm._v(_vm._s(_vm.getTitleInfo.headTitle))]
                    ),
                  ]
                ),
          ],
      _c("span", [_vm._v(_vm._s(_vm.getTitleInfo.name))]),
      _c("img", {
        staticClass: "title-icon2",
        attrs: { src: require("@/assets/image/aigc/sort.png"), alt: "" },
      }),
      _vm.popoverShow
        ? _c("div", { staticClass: "popover", attrs: { id: "popoverId" } }, [
            _c(
              "div",
              { staticClass: "title-list" },
              [
                _vm._l(_vm.getTypeAIList, function (item, ii) {
                  return [
                    !_vm.ignoreList.includes(item.id)
                      ? _c(
                          "div",
                          {
                            key: ii,
                            staticClass: "title-item",
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.change(ii)
                              },
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                class: {
                                  "title-item-content": true,
                                  "title-item-select": item.checked,
                                },
                              },
                              [
                                item.type === "AI"
                                  ? _c("img", {
                                      attrs: {
                                        src: require("@/assets/image/aigc/icon.png"),
                                        alt: "",
                                      },
                                    })
                                  : [
                                      !!item.icon
                                        ? _c("img", {
                                            staticClass: "title-icon",
                                            attrs: { src: item.icon, alt: "" },
                                          })
                                        : _c(
                                            "div",
                                            {
                                              staticClass: "title-span",
                                              style: {
                                                background:
                                                  item.backgroundColor,
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  style: {
                                                    color: item.textColor,
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      item.title.split("")[0]
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                    ],
                                _c("span", [_vm._v(" " + _vm._s(item.name))]),
                              ],
                              2
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                }),
              ],
              2
            ),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }